<template>
  <div>
    <!-- 교육참가 신청-->
    <div v-if="menu === 0">
      <div class="top-navi">
        <div
          v-for="(item, index) in navItem"
          :key="'topNavi' + index"
          :class="['top-navi__item', {selected: item.selected}]"
          @click="onClickNavItem(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="search-wrap">
        <input
          type="text"
          :value="seminarSearchInfo.keyword"
          @input="seminarSearchInfo.keyword = $event.target.value"
          placeholder="검색"
          @keyup.enter="getSeminarListSearch"
        />
        <search-icon class="search-icon" @click="getSeminarListSearch" />
      </div>
      <div class="plan-table">
        <div class="plan-table__top">
          <div class="top-item">분야</div>
          <div class="top-item">상태</div>
          <div class="top-item">주제</div>
          <div class="top-item">교육기간</div>
        </div>
        <div class="plan-table__list">
          <div class="plan-table__item" v-for="(item, index) in seminarListForPlan" :key="'planTable' + index" @click="goDetailPage(item)">
            <div class="table-item">{{ item.typeName }}</div>
            <div class="table-item text-blue-500">{{ item.statusName }}</div>
            <div class="table-item" :class="{'font-bold': item.status === '01'}">{{ item.title }}</div>
            <div class="table-item">{{ item.term }}</div>
          </div>
        </div>
      </div>
      <Pagination
        :total-count="seminarSearchInfo.totalCount"
        :now-page="seminarSearchInfo.page"
        :limit="seminarSearchInfo.limit"
        @changePage="listChangePage"
      />
    </div>
    <!-- 종료된 교육과정-->
    <div v-if="menu === 1">
      <div class="top-navi">
        <div
          v-for="(item, index) in navItem"
          :key="'topNavi' + index"
          :class="['top-navi__item', {selected: item.selected}]"
          @click="onClickEndNavItem(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="search-wrap">
        <input
          type="text"
          :value="endSeminarSearchInfo.keyword"
          @input="endSeminarSearchInfo.keyword = $event.target.value"
          placeholder="검색"
          @keyup.enter="getEndSeminarListSearch"
        />
        <search-icon class="search-icon" @click="getEndSeminarListSearch" />
      </div>
      <div class="end-seminar-table">
        <div class="plan-table__top">
          <div class="top-item">분야</div>
          <div class="top-item">주제</div>
          <div class="top-item">교육기간</div>
        </div>
        <div class="plan-table__list">
          <div class="plan-table__item" v-for="(item, index) in endSeminarList" :key="'endSeminarTable' + index" @click="goDetailPage(item)">
            <div class="table-item">{{ item.typeName }}</div>
            <div class="table-item">{{ item.title }}</div>
            <div class="table-item">{{ item.term }}</div>
          </div>
        </div>
      </div>
      <Pagination
        :total-count="endSeminarSearchInfo.totalCount"
        :now-page="endSeminarSearchInfo.page"
        :limit="endSeminarSearchInfo.limit"
        @changePage="endListChangePage"
      />
    </div>
    <div v-if="menu === 2">
      <div class="my-table">
        <div class="plan-table__top">
          <div class="top-item">과정명</div>
          <div class="top-item">신청날짜</div>
          <div class="top-item">신청인 성명</div>
          <div class="top-item">상태</div>
          <div class="top-item">참석여부</div>
          <div class="top-item">수료증</div>
        </div>
        <div class="plan-table__list">
          <div class="plan-table__item" v-for="(item, index) in mySeminarList" :key="'planTable' + index">
            <div class="table-item">{{ item.title }}</div>
            <div class="table-item">{{ item.applyDate }}</div>
            <div class="table-item">{{ item.applyerName }}</div>
            <div class="table-item">{{ item.status }}</div>
            <div class="table-item">{{ item.isAttend === 1 ? '참석' : '미참석' }}</div>
            <div :class="['table-item', {'print': item.isAttend}]" @click="printCertificate(item)">{{ item.isAttend === 1 ? '출력' : '-' }}</div>
          </div>
        </div>
      </div>
    </div>
    <CertImg v-if="certShow" :my-seminar-certificate="mySeminarCertificate" @close="certShow = false" />
  </div>
</template>

<script>
import {useSeminarStore} from '~/store/seminar/index.js'
import Pagination from '~/components/common/Pagination.vue'
import CertImg from '~/components/seminar/CertImg.vue'
import SearchIcon from 'assets/svg/search-icon.vue'
import {useMemberStore} from '~/store/member/index.js'

export default {
  name: 'SeminarTab2',
  components: {SearchIcon, CertImg, Pagination},
  setup() {
    const store = useSeminarStore()
    const memberStore = useMemberStore()
    return {store, memberStore}
  },
  props: {
    menu: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isAuth: false,
      certShow: false,
      navItem: [
        {
          name: '전체과정',
          selected: false,
          type: ''
        },
        {
          name: '인사',
          selected: false,
          type: 'SMT01'
        },
        {
          name: '노무',
          selected: false,
          type: 'SMT02'
        },
        {
          name: 'HRD',
          selected: false,
          type: 'SMT03'
        },
        {
          name: '기타',
          selected: false,
          type: 'SMT04'
        }
      ],
      seminarListForPlan: [
        {
          id: 0,
          typeName: '',
          title: '',
          term: ''
        }
      ],
      endSeminarList: [
        {
          id: 0,
          typeName: '',
          title: '',
          term: ''
        }
      ],
      seminarSearchInfo: {
        type: '',
        page: 1,
        pageType: 1,
        limit: 10,
        keyword: '',
        totalCount: 0,
      },
      endSeminarSearchInfo: {
        type: '',
        page: 1,
        pageType: 2,
        limit: 10,
        keyword: '',
        totalCount: 0,
      },
      mySeminarList: [
        {
          id: 0,
          title: '',
          applyDate: '',
          applyerName: '',
          status: '',
          isAttend: 0
        }
      ],
      mySeminarCertificate: {
        certificateId: '',
        title: '',
        name: '',
        companyName: '',
        content: '',
        date: '',
        sign: ''
      }
    }
  },
  async mounted() {
    this.setQueryData()
    await this.getSeminarList()
    await this.getEndSeminarList()
    this.isAuth = this.memberStore.isAuthenticated
    if ( this.isAuth ){
      await this.getMySeminarList()
    }
  },
  watch: {
    '$route.query': {
      handler() {
        const type = this.$route.query.type
        const page = this.$route.query.page
        const keyword = this.$route.query.keyword

        if (type || page || keyword) {
          this.navItem.forEach(item => {
            item.selected = item.type === type;
          })
          if ( this.menu === 0 ){
            this.seminarSearchInfo.type = type
            this.seminarSearchInfo.page = Number(page)
            this.seminarSearchInfo.keyword = keyword || ''
            this.getSeminarList()
          } else if ( this.menu === 1 ){
            this.endSeminarSearchInfo.type = type
            this.endSeminarSearchInfo.page = Number(page)
            this.endSeminarSearchInfo.keyword = keyword || ''
            this.getEndSeminarList()
          }
        }
      },
      immediate: true
    },
    // menu가 바뛸때마다 검색조건 초기화
    menu: {
      handler() {
        this.seminarSearchInfo.page = 1
        this.seminarSearchInfo.keyword = ''
        this.seminarSearchInfo.type = ''
        this.endSeminarSearchInfo.page = 1
        this.endSeminarSearchInfo.keyword = ''
        this.endSeminarSearchInfo.type = ''
        // navItem의 selected 상태를 초기화
        this.navItem.forEach(item => {
          item.selected = item.type === this.seminarSearchInfo.type;
        })
      },
      immediate: true
    }
  },
  methods: {
    setQueryData() {
      // 쿼리에서 type, page, keyword를 가져와서 seminarSearchInfo에 설정
      this.seminarSearchInfo.type = this.$route.query.type || ''
      this.seminarSearchInfo.page = Number(this.$route.query.page) || 1
      this.seminarSearchInfo.keyword = this.$route.query.keyword || ''

      this.endSeminarSearchInfo.type = this.$route.query.type || ''
      this.endSeminarSearchInfo.page = Number(this.$route.query.page) || 1
      this.endSeminarSearchInfo.keyword = this.$route.query.keyword || ''

      // navItem의 selected 상태를 초기화
      this.navItem.forEach(item => {
        item.selected = item.type === this.seminarSearchInfo.type;
      })
    },
    async getSeminarListSearch() {
      this.seminarSearchInfo.page = 1
      await this.getSeminarList()
    },
    async getEndSeminarListSearch() {
      this.endSeminarSearchInfo.page = 1
      await this.getEndSeminarList()
    },
    async printCertificate(item) {
      if (item.isAttend === 0) {
        return false
      }
      try {
        const {data} = await this.store.getMySeminarCertificate(item.id)
        this.mySeminarCertificate = data
        this.certShow = true
      } catch (error) {
        console.log(error)
      }
    },
    async getMySeminarList() {
      try {
        const {data} = await this.store.getMySeminarList()
        this.mySeminarList = data
      } catch (error) {
        console.log(error)
      }
    },
    goDetailPage(item) {
      const seminarId = item.id
      let url = `/seminar`
      if ( this.menu === 0 ){
        url += `/${seminarId}?type=${this.seminarSearchInfo.type}&keyword=${this.seminarSearchInfo.keyword}&page=${this.seminarSearchInfo.page}&pageType=1`
      } else if ( this.menu === 1 ){
        url += `/${seminarId}?type=${this.endSeminarSearchInfo.type}&keyword=${this.endSeminarSearchInfo.keyword}&page=${this.endSeminarSearchInfo.page}&pageType=2`
      }
      this.$router.push(url)
    },
    listChangePage(page) {
      this.seminarSearchInfo.page = page
      this.getSeminarList()
      // scroll top 부드럽게
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    endListChangePage(page) {
      this.endSeminarSearchInfo.page = page
      this.getEndSeminarList()
      // scroll top 부드럽게
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    async onClickNavItem(item) {
      this.navItem.forEach(navItem => {
        navItem.selected = false
      })
      item.selected = true
      this.seminarSearchInfo.type = item.type
      this.seminarSearchInfo.page = 1
      await this.getSeminarList()
    },
    async onClickEndNavItem(item) {
      this.navItem.forEach(navItem => {
        navItem.selected = false
      })
      item.selected = true
      this.endSeminarSearchInfo.type = item.type
      this.endSeminarSearchInfo.page = 1
      await this.getEndSeminarList()
    },
    async getSeminarList() {
      try {
        const {data} = await this.store.getSeminarList(this.seminarSearchInfo)
        this.seminarListForPlan = data.list
        this.seminarSearchInfo.totalCount = data.count
        // 검색어가 있으면 키워드 쿼리를 추가해준다
        if ( this.menu === 0){
          this.$router.push(
            `/seminar?menu=1&subMenu=0&type=${this.seminarSearchInfo.type}&keyword=${this.seminarSearchInfo.keyword}&page=${this.seminarSearchInfo.page}`
          )
        }
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    async getEndSeminarList() {
      try {
        const {data} = await this.store.getSeminarList(this.endSeminarSearchInfo)
        this.endSeminarList = data.list
        this.endSeminarSearchInfo.totalCount = data.count
        // 검색어가 있으면 키워드 쿼리를 추가해준다
        if ( this.menu === 1 ){
          this.$router.push(
            `/seminar?menu=1&subMenu=1&type=${this.endSeminarSearchInfo.type}&keyword=${this.endSeminarSearchInfo.keyword}&page=${this.endSeminarSearchInfo.page}`
          )
        }
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    }
  }
}
</script>

<style scoped lang="scss">
.top-navi {
  border-top: 1px solid #dbdbdb;
  border-bottom: 1px solid #dbdbdb;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  .top-navi__item {
    padding: 18px 16px;
    color: #606060;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%; /* 17.5px */
    cursor: pointer;

    &:hover {
      color: #0058aa;
    }

    &.selected {
      font-weight: 700;
      color: #0058aa;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 3px;
        background: #0058aa;
      }
    }
  }
}
.search-wrap {
  padding: 9px;
  border-radius: 4px;
  border: 1px solid #dbdbdb;
  background: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  input {
    border: none;
    width: 100%;
    outline: none;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 17.5px */
    &::placeholder {
      color: #bdbdbd;
    }
  }
  .search-icon {
    cursor: pointer;
  }
}
.plan-table {
  margin-bottom: 24px;
  .plan-table__top {
    display: flex;
    border-bottom: 1px solid #909090;
    background: #fbfbfb;
    .top-item {
      padding: 12px 16px;
      font-size: 14px;
      &:first-child {
        width: 100px;
      }

      &:nth-child(2) {
        width: 100px;
      }

      &:nth-child(3) {
        width: 380px;
      }

      &:last-child {
        width: 170px;
      }
    }
  }
  .plan-table__list {
    .plan-table__item {
      display: flex;
      border-bottom: 1px solid #dbdbdb;
      cursor: pointer;
      &:hover {
        background: #fbfbfb;
      }
      .table-item {
        font-size: 14px;
        padding: 16px;

        &:first-child {
          width: 100px;
        }

        &:nth-child(2) {
          width: 100px;
        }

        &:nth-child(3) {
          width: 380px;
        }

        &:last-child {
          width: 170px;
        }
      }
    }
  }
}

.end-seminar-table {
  margin-bottom: 24px;
  .plan-table__top {
    display: flex;
    border-bottom: 1px solid #909090;
    background: #fbfbfb;
    .top-item {
      padding: 12px 16px;
      font-size: 14px;
      &:first-child {
        width: 100px;
      }
      &:nth-child(2) {
        width: 480px;
      }
      &:last-child {
        width: 170px;
      }
    }
  }
  .plan-table__list {
    .plan-table__item {
      display: flex;
      border-bottom: 1px solid #dbdbdb;
      cursor: pointer;
      &:hover {
        background: #fbfbfb;
      }
      .table-item {
        font-size: 14px;
        padding: 16px;

        &:first-child {
          width: 100px;
        }
        &:nth-child(2) {
          width: 480px;
        }
        &:last-child {
          width: 170px;
        }
      }
    }
  }
}

.my-table {
  margin-bottom: 24px;
  .plan-table__top {
    display: flex;
    border-bottom: 1px solid #909090;
    background: #fbfbfb;
    .top-item {
      text-align: center;
      padding: 12px 16px;
      font-size: 14px;
      font-weight: 500;
      &:first-child {
        width: 275px;
      }
      &:nth-child(2) {
        width: 105px;
      }
      &:nth-child(3) {
        width: 96px;
      }
      &:nth-child(4) {
        width: 82px;
      }
      &:nth-child(5) {
        width: 82px;
      }
      &:last-child {
        width: 70px;
      }
    }
  }
  .plan-table__list {
    .plan-table__item {
      display: flex;
      border-bottom: 1px solid #dbdbdb;

      .table-item {
        font-size: 14px;
        font-weight: 400;
        padding: 16px;
        &:first-child {
          width: 275px;
        }
        &:nth-child(2) {
          text-align: center;
          width: 105px;
        }
        &:nth-child(3) {
          text-align: center;
          width: 96px;
        }
        &:nth-child(4) {
          text-align: center;
          width: 82px;
        }
        &:nth-child(5) {
          text-align: center;
          width: 82px;
        }
        &:last-child {
          text-align: center;
          width: 70px;
        }
        &.print {
          &:hover {
            color: #0058aa;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
